import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  BarChart2,
  Users,
  Briefcase,
  CreditCard,
  LogOut,
  User,
  Menu,
  X,
} from 'lucide-react';

const navItems = [
  { to: '/analytics', icon: BarChart2, label: 'Analytics' },
  { to: '/customers', icon: Users, label: 'Customers' },
  { to: '/businesses', icon: Briefcase, label: 'Businesses' },
  { to: '/subscriptions', icon: CreditCard, label: 'Subscriptions' },
];

const Layout = ({ children }) => {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="sidebar-header">
          <span className="sidebar-logo">PYBusiness Admin</span>
          <button
            className="sidebar-close-btn"
            onClick={() => setSidebarOpen(false)}
          >
            <X size={18} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `nav-item ${isActive ? 'nav-item-active' : ''}`
              }
              onClick={() => setSidebarOpen(false)}
            >
              <Icon size={18} className="nav-icon" />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* Main content */}
      <div className="main-area">
        {/* Top navbar */}
        <header className="topbar">
          <button
            className="hamburger-btn"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu size={20} />
          </button>

          <div className="topbar-right">
            <div className="admin-chip">
              <div className="admin-avatar">
                <User size={16} />
              </div>
              <div className="admin-info">
                <span className="admin-name">{admin?.full_name || 'Admin User'}</span>
                <span className="admin-email">{admin?.email || 'admin@pybusiness.com'}</span>
              </div>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={16} />
              <span>Logout</span>
            </button>
          </div>
        </header>

        {/* Page content */}
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
